import React from 'react';

import * as ManifestUI from '@project44/manifest-ds';

export type InfoWithPopoverProps = {
  tooltipText: string;
};

export const InfoWIthTooltip: React.FC<InfoWithPopoverProps> = ({
  tooltipText,
}) => {
  return (
    <ManifestUI.Tooltip title={tooltipText} placement="top">
      <ManifestUI.reactIcons.InfoCircled css={{ marginLeft: '5px' }} />
    </ManifestUI.Tooltip>
  );
};
